
import React from 'react'
import AlertBox from './AlertBox';
import UsersBox from './UsersBox';
import ProgramBox from './ProgramBox';
import ErrorBoundary from '../../ErrorBoundary';
import { useNavigate } from 'react-router-dom';

function Home() {
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
const navigate = useNavigate();

if(!userInfo){
    navigate('/prelogin');
    return false;
  }
  return (
    <>
        <div style={{
            display:'flex',
            justifyContent:'space-between'
          }}>
            <ErrorBoundary>
              <ProgramBox />
            </ErrorBoundary> 
            <ErrorBoundary>
              <AlertBox /> 
            </ErrorBoundary>  
        </div>
        <ErrorBoundary>
          <UsersBox/>
        </ErrorBoundary>
    </>
  )
}

export default Home